"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = exports.NOOP_IX_DATA = void 0;
exports.NOOP_IX_DATA = Buffer.from([
    0x09, 0xb2, 0x0d, 0x73, 0x81, 0x23, 0xed, 0x66,
]);
/**
 * Runs the no-op instruction
 * This ix does nothing, but can cheaply be added to a transaction to increase compute limit
 * if there isn't space for a compute budget IX.
 * @param program - GalacticMarketplace Program
 * @returns InstructionReturn
 */
function noop(program) {
    return () => __awaiter(this, void 0, void 0, function* () {
        return ({
            instruction: yield program.methods.noop().instruction(),
            signers: [],
        });
    });
}
exports.noop = noop;
//# sourceMappingURL=noop.js.map